import { render, staticRenderFns } from "./AttributeDataRow.vue?vue&type=template&id=6a3fcc6c&scoped=true"
import script from "./AttributeDataRow.vue?vue&type=script&lang=js"
export * from "./AttributeDataRow.vue?vue&type=script&lang=js"
import style0 from "./AttributeDataRow.vue?vue&type=style&index=0&id=6a3fcc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3fcc6c",
  null
  
)

export default component.exports